import { Component, OnInit, OnDestroy } from '@angular/core';
import { CUtilit } from '../../classes/utilit';
import { HomeScreenElement } from '../../classes/json-interface';
import { CST_HOME_DISPOTITION } from '../../components/toolbar/app-tool-bar/app-tool-bar.component';
import { AppToolbarService } from '../../components/toolbar/services/app-toolbar.service';
import { MenuButtonService } from 'src/app/services/menu-button/menu-button.service';
import { LoggedUserService } from 'src/app/services/loged-user/loged-user.service';
import { g_params } from 'src/app/classes/global-param';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit, OnDestroy {

  HTML_ArrayHomeScreenElement: HomeScreenElement[] = [];

  constructor(private mToolbar: AppToolbarService,
              private mMenuButton: MenuButtonService,
              private mLoggeduser: LoggedUserService) { }

  ngOnInit() {
    this.mToolbar.toolbarPageTitle = g_params.g_factoryName;
    this.mToolbar.setDisposition(CST_HOME_DISPOTITION);
    this.HTML_ArrayHomeScreenElement = this.mMenuButton.getArrayMenuItem();
  }

  ngOnDestroy(): void {

  }

  public get getNgClassStyleColor() {
    return CUtilit.getNgStyleBorderColor(
      this.mLoggeduser.isArmaorUserConnected,
      this.mLoggeduser.isCustomerConnected
    );
  }

}
